import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SortButton from '../../sort-button';

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    /** Trick per aggiungere il margin top agli elementi che wrappano, 
        quindi gli elementi della prima riga non risentiranno del margine top */
    margin-top: -8px;

    & > label {
        margin-right: 8px;
        margin-top: 8px;
    }
`;

const TheoryTypeSelector = ({ microThemeId, availableTheories, onChange = () => {}, selectedType }) => {
    /**
     * Called on button click to change type.
     * @param {string} type
     */
    const changeType = (type) => {
        onChange(type);
    };

    return (
        <Container>
            {availableTheories.map((item, index) => {
                return (
                    <SortButton
                        key={index}
                        checked={item.type === selectedType}
                        onChange={(checked) => checked && changeType(item.type)}
                        inputType="radio"
                        inputName={microThemeId}
                    >
                        {item.title}
                    </SortButton>
                );
            })}
        </Container>
    );
};

TheoryTypeSelector.propTypes = {
    selectedType: PropTypes.string,
    microThemeId: PropTypes.string,
    availableTheories: PropTypes.array,
    onChange: PropTypes.func,
};

export default TheoryTypeSelector;
